import { fileToWebP, blobToDataUri, newImageName } from './image.js';

export class PendingImages {
  constructor() {
    this.items = [];
  }

  async addFile(file) {
    const blob = await fileToWebP(file);
    const name = newImageName();
    const dataUri = await blobToDataUri(blob);
    const item = { name, file: new Blob([blob], { type: 'image/webp' }), dataUri, inContent: false };
    this.items.push(item);
    return item;
  }

  pushItems(list) {
    this.items.push(...list);
  }

  imageCount() {
    return this.items.filter((i) => i.inContent).length;
  }
}

export function buildPublishContent(markdown, items) {
  let out = markdown;
  for (const it of items) {
    if (it.dataUri && out.includes(it.dataUri)) {
      out = out.split(it.dataUri).join(`upload:${it.name}`);
      it.inContent = true;
    } else {
      it.inContent = false;
    }
  }
  return out;
}

export function markdownToExcerpt(markdown, max = 220) {
  const text = markdown
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/[#*`>_~-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > max ? text.slice(0, max) + '…' : text;
}
